/**
 * What a job must carry before the server will let it complete — the web mirror of
 * COMPLETION_REQUIRED_FIELDS / COURTESY_COMPLETION_REQUIRED_FIELDS in
 * functions/jobStateMachine.js. The server is the authority; this only lets the UI
 * mark a field "outstanding" (amber: required, not yet supplied) before anyone taps
 * Complete. tests/completion.test.mjs fails if the two lists drift apart.
 */
export type CompletionField =
  | 'registrationNumber' | 'make' | 'model' | 'colour' | 'fuelType' | 'transmission'
  | 'pickupLocation' | 'dropoffLocation' | 'customerName'
  | 'courtesyCarRegistration' | 'vehicleMileage' | 'courtesyCarMileage';

export const COMPLETION_FIELDS: ReadonlyArray<{ field: CompletionField; label: string }> = [
  { field: 'registrationNumber', label: 'registration' },
  { field: 'make', label: 'make' },
  { field: 'model', label: 'model' },
  { field: 'colour', label: 'colour' },
  { field: 'fuelType', label: 'fuel type' },
  { field: 'transmission', label: 'transmission' },
  { field: 'pickupLocation', label: 'pickup location' },
  { field: 'dropoffLocation', label: 'drop-off location' },
  { field: 'customerName', label: 'customer' },
];

// Both mileage readings are optional (Bobby, 30 Oct 2026): only the registration is required.
export const COURTESY_COMPLETION_FIELDS: ReadonlyArray<{ field: CompletionField; label: string }> = [
  { field: 'courtesyCarRegistration', label: 'courtesy car registration' },
];

type CompletionSource = Partial<Record<CompletionField, unknown>> & { courtesyCarRequired?: boolean };

/** Required fields that are still empty, in the server's order. */
export function missingCompletionFields(job: CompletionSource): Array<{ field: CompletionField; label: string }> {
  const required = job.courtesyCarRequired === true
    ? [...COMPLETION_FIELDS, ...COURTESY_COMPLETION_FIELDS]
    : COMPLETION_FIELDS;
  return required.filter(({ field }) => !String(job[field] ?? '').trim());
}
